import { onError } from '@apollo/client/link/error'
import { addBreadcrumb } from '@sentry/react'

export const sentryLink = onError(({ networkError, graphQLErrors, operation }) => {
  const operationDefinition = operation.query.definitions.find(
    (q) => q.kind === 'OperationDefinition'
  )

  // All apollo errors get breadcrumbs added to sentry, non errors are ignored as they are tracked using the default breadcrumbs for network requests
  const errorCodes = [
    networkError?.result?.code,
    ...(graphQLErrors?.map((e) => e.extensions?.code) ?? [])
  ].filter(Boolean)

  const message = [
    operationDefinition?.operation,
    operation.operationName,
    errorCodes.length && `[${errorCodes.join(', ')}]`
  ]
    .filter(Boolean)
    .join(' ')

  if (networkError) {
    if (process.env.NODE_ENV === 'development')
      console.error('[Apollo Network Error]', message, JSON.stringify(networkError.result))
    addBreadcrumb({
      category: 'apolloError',
      level: 'error',
      type: 'error',
      message,
      data: {
        error: networkError.result
      }
    })
  }

  if (graphQLErrors?.length) {
    if (process.env.NODE_ENV === 'development')
      console.error('[Apollo Error]', message, graphQLErrors)
    addBreadcrumb({
      category: 'apolloError',
      level: 'error',
      type: 'error',
      message,
      data: {
        error: graphQLErrors.map((e) => ({
          path: e.path?.join('->'),
          message: e.message,
          code: e.extensions?.code,
          sellpyCode: e.extensions?.sellpyCode,
          details: e.extensions?.details
        }))
      }
    })
  }
})
